export default __webpack_public_path__ + "static/media/image-404.04e3a08c.png";